import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
  makeStyles,
  Typography,
} from '@material-ui/core'
import { CustomTooltip } from './CustomTooltip'

export interface ButtonProps extends MuiButtonProps {
  hotkey?: string
  bgColor?: string
  tooltip?: string | React.ReactElement
  scaleUp?: boolean
  className?: string
}

export const Button = ({
  variant,
  bgColor,
  tooltip,
  scaleUp,
  className,
  ...props
}: ButtonProps): JSX.Element => {
  const useStyles = makeStyles((theme) => ({
    contained: {
      color: 'white',
      '&:hover': {
        background: theme.palette.primary.light,
      },
      my: 4,
      borderRadius: '0.375rem',
      paddingLeft: '16px',
      paddingRight: '16px',
      background: theme.palette.primary.main,
      transition: '0.2s',
    },
    outlined: {
      color: bgColor || theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: '0.375rem',
      '&:hover': {
        background: 'rgba(0,0,0,0.04)',
      },
      paddingLeft: '16px',
      paddingRight: '16px',
    },
    disabled: {
      color: ` ${theme.palette.primary.main}70 !important`,
      border: `1px solid ${theme.palette.primary.main}70 !important`,
      borderRadius: '0.375rem',
      '&:hover': {
        background: 'transparent',
      },
      paddingLeft: '16px',
      paddingRight: '16px',
    },
    text: {
      textTransform: 'none',
    },
    scaleUp: {
      transform: 'scale(1.3)',
    },
  }))
  const classes = useStyles()
  const buttonComponent = (
    <MuiButton
      className={`${!props.disabled ? classes[variant || 'text'] : classes.disabled} ${
        scaleUp ? classes.scaleUp : ''
      } ${className}`}
      {...props}
    >
      {props.children}
    </MuiButton>
  )

  if (tooltip)
    return (
      <CustomTooltip title={tooltip}>
        <div>{buttonComponent}</div>
      </CustomTooltip>
    )

  if (props.hotkey)
    return (
      <CustomTooltip title={<Typography>{props.hotkey}</Typography>}>
        <span>{buttonComponent}</span>
      </CustomTooltip>
    )

  return buttonComponent
}
